// @todo: Migrate to 'Select' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Select} from '@wandb/weave/components/Form/Select';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import * as Panel2 from '@wandb/weave/components/Panel2/panel';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import {
  opArtifactMembershipCollection,
  opArtifactMembershipVersionIndex,
  opArtifactName,
  opArtifactProject,
  opArtifactType,
  opArtifactTypeName,
  opDict,
  opEntityName,
  opProjectEntity,
  opProjectName,
  OutputNode,
} from '@wandb/weave/core';
import {useNodeValue} from '@wandb/weave/react';
import React, {useState} from 'react';

import {
  Banner,
  BannerBoldText,
  BannerFlexWrapper,
  BannerTextWrapper,
} from '../../Banner';
import {CodeSnippet} from '../../CodeSnippet';
import {isOrgRegistryProjectName} from '../../Registries/common/utils';
import {sdkVersionsTab} from '../../Registries/Registry/SDKVersionContext';
const inputType = 'artifactMembership' as const;
type ConfigType = {};

export const PanelArtifactMembershipAPI: React.FC<
  Panel2.PanelProps<typeof inputType, ConfigType>
> = ({input: artifactMembershipNode}) => {
  const {loading, result} = useNodeValue(
    React.useMemo(() => {
      const artifactNode = opArtifactMembershipCollection({
        artifactMembership: artifactMembershipNode,
      });
      const artifactTypeNode = opArtifactType({artifact: artifactNode});
      const artifactProjectNode = opArtifactProject({
        artifact: artifactNode,
      });
      return opDict({
        artifactTypeName: opArtifactTypeName({
          artifactType: artifactTypeNode,
        }),
        entityName: opEntityName({
          entity: opProjectEntity({
            project: artifactProjectNode,
          }),
        }),
        projectName: opProjectName({
          project: artifactProjectNode,
        }),
        artifactName: opArtifactName({
          artifact: artifactNode,
        }),
        versionIndex: opArtifactMembershipVersionIndex({
          artifactMembership: artifactMembershipNode,
        }),
      } as any) as unknown as OutputNode<'any'>;
    }, [artifactMembershipNode])
  );
  const [sdkVersionValue, setSdkVersionValue] = useState(
    sdkVersionsTab.lowerSdkVersion.value
  );
  const targetPath = React.useMemo(() => {
    if (!result) {
      return '';
    }
    if (sdkVersionValue === sdkVersionsTab.lowerSdkVersion.value) {
      return `${result.entityName}/${result.projectName}/${result.artifactName}:v${result.versionIndex}`;
    }
    return `${result.projectName}/${result.artifactName}:v${result.versionIndex}`;
  }, [result, sdkVersionValue]);

  if (loading) {
    return <></>;
  }
  return (
    <Tailwind>
      <div className="mb-10">
        {isOrgRegistryProjectName(result.projectName) && (
          <Select
            options={[
              sdkVersionsTab.lowerSdkVersion,
              sdkVersionsTab.higherSdkVersion,
            ]}
            defaultValue={sdkVersionsTab.lowerSdkVersion}
            onChange={selected => {
              if (selected != null && selected.value) {
                setSdkVersionValue(selected.value);
              }
            }}
            className="mt-6 w-full"
          />
        )}
        <CodeSnippet
          codeSnippet={`import wandb
run = wandb.init()
artifact = run.use_artifact('${targetPath}', type='${result.artifactTypeName}')
artifact_dir = artifact.download()`}
        />
      </div>
    </Tailwind>
  );
};

export const RestrictedUsageBanner = () => {
  return (
    <Tailwind>
      <div className="pb-24 pt-16">
        <Banner data-test="registry-info-banner" variant="info">
          <BannerFlexWrapper>
            <div>
              <Icon name="lock-closed" />
            </div>
            <BannerTextWrapper className="px-15">
              <span>
                <BannerBoldText>
                  You don't have permission to access to this content.{' '}
                </BannerBoldText>
                Contact your administrator to request access.
              </span>
            </BannerTextWrapper>
          </BannerFlexWrapper>
        </Banner>
      </div>
    </Tailwind>
  );
};
